import { createSelector } from 'reselect';
import PredesTimelinessDetailsColumns
  from '../../containers/PredesTimelinessDetailsColumns';
import ReportDefinitions from '../../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.PREDES_TIMELINESS_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.PREDES_TIMELINESS_DETAILS.isLoading;

export const getData =
  ReportDefinitions.PREDES_TIMELINESS_DETAILS.getDataFunction();

export const getColumns = createSelector(getData, PredesTimelinessDetailsColumns);
